import { Routes, Route } from "react-router-dom";
import HallHome from "./Pages/HallHome/HallHome";
import HallAbout from "./Pages/HallAbout/HallAbout";
import HallMenu from "./Pages/HallMenu/HallMenu";
import ScrollToTop from "./ScrollToTop";
import AllHallsPage from "./Pages/AllHallsPage/AllHallsPage";
import HallReservationPage from "./Pages/HallReservationPage/HallReservationPage";
import HallGallery from "./Pages/HallGallery/HallGallery";
import HallContact from "./Pages/HallContact/HallContact";
import SeasonalAnimation from "./Components/SeasonalAnimation/SeasonalAnimation";
import HallsNewlyweds from "./Pages/HallsNewlyweds/HallsNewlyweds";
import PopupManager from "./Components/PopupManager/PopupManager";

function App() {
  const currentDate = new Date();

  return (
    <ScrollToTop>
      <PopupManager />
      <SeasonalAnimation currentDate={currentDate} />
      <Routes>
        <Route path="/" element={<HallHome />} />
        <Route path="/mladenci" element={<HallsNewlyweds />} />
        <Route path="/o-nama" element={<HallAbout />} />
        <Route path="/meni" element={<HallMenu />} />
        <Route path="/sale" element={<AllHallsPage />} />
        <Route path="/rezervacije" element={<HallReservationPage />} />
        <Route path="/galerija" element={<HallGallery />} />
        <Route path="/kontakt" element={<HallContact />} />
      </Routes>
    </ScrollToTop>
  );
}

export default App;
